export default {"src":"/_next/static/media/lending-calc-icon.cb885249.svg","height":80,"width":120,"blurWidth":0,"blurHeight":0};